export default function EmptyState({ children }) {
  return <div className="table empty">{children}</div>;
}
